angular.module('portal.i18n').constant('DefaultLocale', 'en_GB');
